import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SECURITY_PROFILE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import SecurityProfileForm from './SecurityProfileForm';
import { postSecurityProfile } from '../../../../actions/security/SecurityProfile';

export const NewSecurityProfile = ({ dispatchPostSecurityProfile, loading, breadcrumbs }) => {

  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };
    newFormValues.securityVisibility = formValues.securityVisibility.value;

    const formViewIds = formValues.viewAuthorizationList || [];
    newFormValues.viewAuthorizationList = formViewIds.map(
      item => ({ viewId: item.value })
    );

    const formEndpointIds = formValues.authorizedEndpointList || [];
    newFormValues.authorizedEndpointList = formEndpointIds.map(
      item => ({ endpointId: item.value })
    );

    dispatchPostSecurityProfile(newFormValues);
  };

  const content = loading ? (
    <Loader />
  ) : (
    <SecurityProfileForm
      onSubmit={onSubmit}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nuevo Perfil de Seguridad"
      subtitle="Crear un perfil de seguridad"
      content={content}
    />
  );
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Seguridad',
      href: SECURITY_PROFILE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
  loading: !SecurityUnit.SecurityProfile.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchPostSecurityProfile: postSecurityProfile,
};

NewSecurityProfile.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostSecurityProfile: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

NewSecurityProfile.defaultProps = {
  loading: false,
};

export default connect(mapStateToProps,mapDispatchToProps)(NewSecurityProfile);
